module.exports = __webpack_public_path__ + "static/media/br.6827f261.png";